import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RegionsSelector } from '@reveni-io/reveni-ui'

import { groupRegionsByContinent } from '@/common/helpers/helpers'

import { resolveRegionValues } from './helpers'

const RegionInput = ({ value, onChange, comboItems, disabled }) => {
  const { t } = useTranslation()
  const regions = comboItems || []
  const groupedRegions = useMemo(() => groupRegionsByContinent(regions), [regions])
  const resolvedValue = resolveRegionValues(value, regions)

  return (
    <RegionsSelector
      label={t('Regiones')}
      regions={groupedRegions || []}
      value={resolvedValue}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

export default RegionInput
